import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Right Business">
                            <h2>Hire The Right Business Automation Consultants</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>We help startups to enterprise-grade corporations that wish to accelerate business
                            performance with automation opportunities. Here is what automation looks like for different
                            journeys of businesses.</p>
                        <p>
                            Automated customer engagement is the most basic face of automation and any entrepreneur’s
                            route to ready. It boosts customer representation and significantly improves brand loyalty.
                        </p>
                        <p> AI and ML-based automation can look different in diverse industrial settings. This is ideal
                            for mid-level companies planning to optimize their product design and manufacturing
                            facilities through professional business automation consultants.
                        </p>
                        <p> Business Process automation involves building massive data centers and cloud infrastructures
                            that self-collect, process, analyze and build onto data. More advanced forms of automation
                            include robotic process automation that blends business processes, workforce, and
                            intelligence.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;